import Immutable from 'immutable';

const Content: {
  type: string,
  smart: boolean,
  unit: string | null,
  fileRegex: string | null,
  pickable: boolean,
  captions: Immutable.List<string> | null,
  values: Immutable.List<{}> | null,
  itemNames: Immutable.List<string> | null,
  itemDisplayNames: Immutable.List<string> | null,
  itemTypes: Immutable.List<any> | null,
  server: string | null,
  method: string | null,
  parameters: Immutable.OrderedMap<string, any> | null,
  parameterTypes: Immutable.OrderedMap<string, string> | null,
  addNone: boolean,
  resultType: string,
  screeningEditable: boolean,
  dotshapeEditable: boolean,
  mergeEditable: boolean,
  composite: boolean,
  screeningValuesInTicket: boolean,
  shareName: string | null,
  subFolderName: string | null,
  extension: string | null,
  presets: Immutable.List<string> | null
} = {
  type: '',
  smart: false,
  unit: null,
  fileRegex: null,
  pickable: false,
  captions: null,
  values: null,
  itemNames: null,
  itemDisplayNames: null,
  itemTypes: null,
  server: null,
  method: null,
  parameters: null,
  parameterTypes: null,
  addNone: false,
  resultType: 'ListOfStrings',
  screeningEditable: false,
  dotshapeEditable: false,
  mergeEditable: false,
  composite: false,
  screeningValuesInTicket: false,
  shareName: null,
  subFolderName: null,
  extension: null,
  presets: null
};

class TypeInfo extends Immutable.Record(Content) {
  static get Type () {
    return {
      Implicit: 'Implicit',
      Password: 'Password',
      Int8: 'Int8',
      Int16: 'Int16',
      Int32: 'Int32',
      Int64: 'Int64',
      UInt8: 'UInt8',
      UInt16: 'UInt16',
      UInt32: 'UInt32',
      UInt64: 'UInt64',
      String: 'String',
      Float: 'Float',
      Double: 'Double',
      Boolean: 'Boolean',
      SmartText: 'SmartText',
      UInt32Duration: 'UInt32Duration',
      DateTime: 'DateTime',
      SeparationName: 'SeparationName',
      LayerName: 'LayerName',
      SoapBlob: 'SoapBlob',
      EncryptedPassword: 'EncryptedPassword',
      Unit: 'Unit',
      Url: 'Url',
      Popup: 'Popup',
      List: 'List',
      InkSelection: 'InkSelection',
      CustomSettings: 'CustomSettings',
      RPC: 'RPC'
    };
  }
}



export default TypeInfo;
